<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <v-row v-if="componenteEvento.agregar_submodulo">

      <v-col cols="12" class="d-flex justify-end">
        <ButtonComp icon-but="fas fa-cash-register" text-button="Pagar" @click="showBatchItems" normal-button
          class="mx-2" />
        <ButtonComp @click="showExportData" normal-button text-button="Generar reporte" class-color="success"
          icon-but="fas fa-file" />
      </v-col>
    </v-row>

    <!-- consultar -->
    <v-row>
      <v-col cols="12" md="2" sm="2" class="py-0">
        <v-autocomplete label="Nivel" v-model="filtro.id_nivel" :items="lista_filtro_niveles" item-value="id"
          item-text="desc_nivel" @change="changeFiltroNivel()" autocomplete="off">
        </v-autocomplete>
      </v-col>

      <v-col cols="12" md="2" sm="2" class="py-0">
        <v-autocomplete label="Grado" v-model="filtro.id_grado" :items="lista_filtro_grados" item-value="id"
          item-text="desc_grado" @change="changeFiltroGrado()" autocomplete="off">
        </v-autocomplete>
      </v-col>

      <v-col cols="12" md="2" sm="2" class="py-0">
        <v-autocomplete label="Sección" v-model="filtro.id_seccion" :items="lista_filtro_secciones" item-value="id"
          item-text="nombre_seccion" @change="changeFiltroSeccion()" autocomplete="off">
        </v-autocomplete>
      </v-col>

      <v-col cols="12" md="3" sm="3" class="py-0">
        <v-text-field label="Documento de identidad" type="text" v-model="filtro.documento_identidad"
          @change="changeFiltroDocumentoIdentidad()">
        </v-text-field>
      </v-col>

      <v-col cols="12" md="3" sm="3" class="py-0">
        <v-text-field label="Estudiante" type="text" v-model="filtro.nombre_estudiante"
          @change="changeFiltroNombreEstudiante()">
        </v-text-field>

      </v-col>

      <v-col cols="12">
        <ComundataTablecomp :headers="PagospendientesHeaders" :items="listItems" :search="search"
          item-key="id_asig_movimiento_pago" v-model="selectedItems" whit-search whit-select unselectable
          :loading="loading">
          <template v-slot:fecha_vencimiento="{ item }">
            {{ item.fecha_vencimiento | filtroFecha }}
          </template>
        </ComundataTablecomp>
      </v-col>
    </v-row>


    <v-row class="pt-5">
      <v-col class="d-flex flex-row-reverse pt-0">
        <input style="background-color: #d9d9d9; width: 100px;" class="mx-2 text-right" disabled :value="totalTotal" />
        <input style="background-color: #d9d9d9; width: 100px;" class="mx-2 text-right" disabled :value="dctoMonto" />
        <input style="background-color: #d9d9d9; width: 100px;" class="mx-2 text-right" disabled :value="becaMonto" />
        <input style="background-color: #d9d9d9; width: 100px;" class="mx-2 text-right" disabled :value="moraMonto" />
        <input style="background-color: #d9d9d9; width: 100px;" class="mx-2 text-right" disabled :value="totalMonto" />
        S/
      </v-col>
    </v-row>

    <!-- Modal -->
    <v-form ref="formDatos" lazy-validation>
      <v-dialog v-model="showDialog" persistent scrollable max-width="600px">
        <v-card>
          <v-card-title class="btn_otro">
            <v-row class="d-flex justify-space-between py-0">
              {{ formTitle }}
              <v-btn fab dark x-small class="btn_style3" @click="showDialog = false"><v-icon
                  dark>fa-times</v-icon></v-btn>
            </v-row>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" md="12" class="pt-5 text-center">
                <span
                  class="px-3 py-3 btn_pendiente v-btn v-btn--is-elevated v-btn--has-bg theme--light btn_pendiente text-center">
                  Nivel: {{ editedItem.desc_nivel }} &nbsp;&nbsp;&nbsp; Grado: {{ editedItem.desc_grado }}
                  &nbsp;&nbsp;&nbsp;
                  Seccion: {{ editedItem.nombre_seccion }} <br />Estudiante: {{ editedItem.nombre_estudiante }}
                </span>
              </v-col>

              <v-col cols="12" sm="6" md="6" class="py-0">
                <v-menu v-model="menu_fecha_pago" :close-on-content-click="true" transition="scale-transition" offset-y
                  max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="fechaPagoFormatted" label="Fecha" readonly v-on="on"
                      :rules="[rul.required]"></v-text-field>
                  </template>

                  <v-date-picker v-model="editedItem.fecha_pago" no-title @input="menu_fecha_pago = false">
                  </v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="6" md="6" class="py-0">
                <v-select label="Método Pago" v-model="editedItem.id_metodo_pago" :items="lista_metodo_pagos"
                  item-value="id_metodo_pago" item-text="nombre_metodo_pago" :rules="[rul.selectReq]">
                </v-select>
              </v-col>

              <v-col cols="12" sm="6" md="6" class="py-0">
                <v-select label="Moneda" v-model="editedItem.id_moneda_monto_pagado" :items="lista_monedas"
                  item-value="id_moneda" item-text="nombre_moneda" :rules="[rul.selectReq]">
                </v-select>
              </v-col>

              <v-col cols="12" sm="6" md="6" class="py-0">
                <v-text-field label="Monto" type="number" :readonly="true" v-model="editedItem.monto_pagado"
                  :rules="[rul.selectReq]">
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="12" md="12" class="py-0">
                <v-text-field label="Observación" type="text" v-model="editedItem.observacion_pago"
                  :rules="[rul.required, rul.min4, rul.max100]">
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="6" class="py-0">
                <v-text-field label="N de voucher / transferencia / cheque" type="text"
                  v-model="editedItem.numero_operacion" :rules="[rul.max30]">
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="6" class="py-0">
                <v-text-field label="N de Celular" type="text" v-model="editedItem.numero_celular" :rules="[rul.max20]">
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="12" md="12" class="py-0">
                <v-file-input v-model="archivoSubir" accept=".docx,.pdf,.doc" label="Adjuntar comprobante"
                  :rules="[rul.required]"></v-file-input>
              </v-col>

            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="btn_style3" dark @click="showDialog = false">Cancelar</v-btn>

            <v-btn :style="{ color: '#ffffff' }" class="btn_block_style2" :disabled="btnIsSaving"
              @click="saveItem(editedItem ? editedItem.id_asig_becado : 0)">{{ isNew ? 'Guardar' : 'Guardar Cambios'
              }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>

    <confirm @aceptar="editItem" @cancelar="cancelConfirm" :title="confirm.title" :active="confirm.active" />
  </div>
</template>

<script>
import axios from "../../../../helpers/axios";
import CommonRules from "../../commonRules";
import ComundataTablecomp from "../../../../components/ComponentsEst/ComundataTablecomp.vue";
import ButtonComp from "../../../../components/ComponentsEst/TableButtonComp.vue";
import { mapMutations, mapGetters, mapActions } from "vuex";
import { PagospendientesHeaders } from '../../../../helpers/headersTable';

export default {
  components: {
    ComundataTablecomp,
    ButtonComp
  },
  data: () => ({
    paramComponente: { id_submodulo: 2, id_modulo: 4 },
    dataSession: sessionStorage,
    PagospendientesHeaders,
    selectedItems: [],
    showDialog: false,
    btnIsSaving: false,
    loading: false,
    filtro: {
      id_nivel: null,
      id_grado: null,
      id_seccion: null,
      documento_identidad: null,
      nombre_estudiante: null
    },
    search: "",
    confirm: {
      id: 0,
      title: "",
      active: false,
    },

    rul: CommonRules(),
    archivoSubir: null,
    menu_fecha_pago: false,
    listItems: [],
    lista_filtro_niveles: [],
    lista_filtro_grados: [],
    lista_filtro_secciones: [],
    lista_metodo_pagos: [],
    lista_monedas: [],
    isNew: true,
    editedItem: {},
  }),

  computed: {
    formTitle() {
      return this.isNew ? "Registro de Deuda" : "Editar Registro de Deuda";
    },
    totalMonto() {
      let result = 0;
      this.selectedItems.forEach((items) => {
        result += items.monto;
      });
      return result;
    },
    moraMonto() {
      let result = 0;
      this.selectedItems.forEach((items) => {
        result += items.mora;
      });
      return result;
    },
    becaMonto() {
      let result = 0;
      this.selectedItems.forEach((items) => {
        result += items.beca;
      });
      return result;
    },
    dctoMonto() {
      let result = 0;
      this.selectedItems.forEach((items) => {
        result += items.dcto;
      });
      return result;
    },
    totalTotal() {
      let result = 0;
      this.selectedItems.forEach((items) => {
        result += items.monto + items.mora;
      });
      return result;
    },
    fechaPagoFormatted() {
      return this.formatDate(this.editedItem.fecha_pago);
    },

    ...mapGetters("login", ["componenteEvento"]),
  },
  mounted() {
    this.getListaNivelesFiltro();
    this.getListaAsigPagoPendientes();
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    async showBatchItems() {
      if (this.selectedItems.length > 0) {
        this.confirm.id = 0;
        this.confirm.title = "¿Está seguro de pagar los registros seleccionados?";
        this.confirm.active = true;
      }
    },

    cancelConfirm() {
      this.confirm.id = 0;
      this.confirm.title = "";
      this.confirm.active = false;
    },

    async changeFiltroNivel() {
      await this.getListaGradosFiltro();
      await this.getListaAsigPagoPendientes();
    },

    async changeFiltroGrado() {
      await this.getListaSeccionesFiltro();
      await this.getListaAsigPagoPendientes();
    },

    async changeFiltroSeccion() {
      await this.getListaAsigPagoPendientes();
    },

    async changeFiltroDocumentoIdentidad() {
      await this.getListaAsigPagoPendientes();
    },

    async changeFiltroNombreEstudiante() {
      await this.getListaAsigPagoPendientes();
    },

    async editItem() {
      this.editedItem = {};
      this.confirm.active = false;
      console.log(this.selectedItems)
      const params = this.selectedItems.map(x => ({
        id_asig_movimiento_pago: x.id_asig_movimiento_pago,
        documento_identidad: x.documento_identidad,
        desc_nivel: x.desc_nivel,
        desc_grado: x.desc_grado,
        nombre_seccion: x.nombre_seccion,
        nombre_estudiante: x.nombre_estudiante,
        monto: x.monto,
      }));
      let monto_pagado = 0;
      params.forEach(x => {
        monto_pagado += x.monto;
      });

      this.editedItem.items = params;
      this.editedItem.documento_identidad = params[0].documento_identidad;
      this.editedItem.desc_nivel = params[0].desc_nivel;
      this.editedItem.desc_grado = params[0].desc_grado;
      this.editedItem.nombre_seccion = params[0].nombre_seccion;
      this.editedItem.nombre_estudiante = params[0].nombre_estudiante;
      this.editedItem.monto_pagado = monto_pagado;
      this.btnIsSaving = false;
      this.isNew = false;
      this.getListaMonedas();
      this.getListaMetodoPagos();
      this.showDialog = true;
    },

    /// FILTROS

    getListaNivelesFiltro() {
      this.lista_filtro_niveles = [];
      let params = {
        id_colegio: this.dataSession.id_colegio,
        id_anio: this.dataSession.id_ano_lectivo,
      };

      axios
        .post("/tesoreria/common/nivel", params)
        .then((response) => {
          this.lista_filtro_niveles = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaGradosFiltro() {
      this.lista_filtro_grados = [];
      let params = {
        id_colegio: this.dataSession.id_colegio,
        id_nivel: this.filtro.id_nivel
      };

      axios
        .post("/sistema/integral/getGradoAdm/", { filter: params })
        .then((response) => {
          this.lista_filtro_grados = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaSeccionesFiltro() {
      this.lista_filtro_secciones = [];
      const params = {
        id_colegio: this.dataSession.id_colegio,
        id_anio: this.dataSession.id_ano_lectivo,
        id_nivel: this.filtro.id_nivel,
        id_grado: this.filtro.id_grado
      };
      axios
        .post("/tesoreria/common/seccion", params)
        .then((response) => {
          this.lista_filtro_secciones = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaMonedas() {
      axios
        .get("/tesoreria/common/moneda")
        .then((response) => {
          this.lista_monedas = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaMetodoPagos() {
      axios
        .get("/tesoreria/common/metodo_pago")
        .then((response) => {
          this.lista_metodo_pagos = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    async getListaAsigPagoPendientes() {
      this.selectedItems = [];
      this.loading = true;
      this.filtro.id_colegio = this.dataSession.id_colegio;
      this.filtro.id_anio = this.dataSession.id_ano_lectivo;
      await axios
        .post("/tesoreria/asignacion/pago_pendiente/consulta", this.filtro)
        .then((response) => {
          this.listItems = response.data;
          this.loading = false;
        }).catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e.error}`, tiempo: null });
          this.loading = false;
        });
    },

    async saveItem(id = 0) {
      console.log(id);
      if (this.$refs.formDatos.validate()) {
        this.btnIsSaving = true;
        try {
          const params = Object.assign({}, this.editedItem);
          params["user_id"] = this.dataSession.id;
          params["colegio_id"] = this.dataSession.id_colegio;

          //1.- Se crea el pago
          let response = await axios.post("/tesoreria/asignacion/pago_pendiente/pago_batch", params);

          //2.- Se manda el comprobante al SPACE y se le actualiza la 'url_comprobante'
          const formData = new FormData();

          formData.append("subirArchivo", this.archivoSubir);
          formData.append("colegio_id", params.colegio_id);
          formData.append("documento_identidad", params.documento_identidad);
          formData.append("id_movimiento_pago", response.data.data.lista[0].id_asig_movimiento_pago);
          let response2 = await axios.post("/tesoreria/asignacion/pago_pendiente/comprobante_space", formData);

          this.showDialog = false;
          this.setEnviarMens({ tipo: `${response2.data.messageT}`, mensaje: `${response2.data.message}`, tiempo: null });
          this.getListaAsigPagoPendientes();
        }
        catch (error) {
          this.btnIsSaving = false;
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      }
    },

    async showExportData() {
      try {
        const params = this.filtro;
        const nivel_desc = this.lista_filtro_niveles.filter(x => x.id == params.id_nivel);
        params.nivel_desc = nivel_desc.length > 0 ? nivel_desc[0]['desc_nivel'] : '';
        const grado_desc = this.lista_filtro_grados.filter(x => x.id == params.id_grado);
        params.grado_desc = grado_desc.length > 0 ? grado_desc[0]['desc_grado'] : '';
        const nombre_seccion = this.lista_filtro_secciones.filter(x => x.id == params.id_seccion);
        params.nombre_seccion = nombre_seccion.length > 0 ? nombre_seccion[0]['nombre_seccion'] : '';
        params.id_anio = this.dataSession.id_ano_lectivo;
        params.id_colegio = this.dataSession.id_colegio;

        let response = await axios.post("/tesoreria/report/consulta/rpt_pagos_pendientes", params);
        if (response.data.error == 1) {
          this.setEnviarMens({ tipo: "E", mensaje: `${response.data.message}`, tiempo: null });
        }
        else {
          let archivoADescargar = '';
          let dataResponse = response.data
          this.setEnviarMens({ tipo: dataResponse.messageT, mensaje: dataResponse.message, tiempo: 3000 })
          this.generandoReporte = 0
          if (dataResponse.messageT == 'S') {
            archivoADescargar = dataResponse.fileToDownload;
            axios({
              url: '/tesoreria/report/bajarReporte/' + dataResponse.nameReport,
              method: 'GET',
              responseType: 'blob',
            }).then((response) => {
              this.setEnviarMens({ tipo: 'S', mensaje: 'Descargando reporte', tiempo: 3000 })

              const url = window.URL.createObjectURL(new Blob([response.data]));
              console.log(response.data)
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', archivoADescargar);
              document.body.appendChild(link);
              link.click();
              link.remove()
              window.URL.revokeObjectURL(url);
            });
          }
        }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
  },
};
</script>